/* eslint-disable import/no-default-export, import/order, max-lines, max-lines-per-function, no-nested-ternary, react/no-unescaped-entities, react/prop-types */
// @ts-expect-error TS(6133): 'React' is declared but its value is never read.
import React, { useState, useEffect } from "react";
import { cn } from "tailwind-variants";
import { getQueryParams, removeQueryParam } from "common/utils/browser";
import { submitDtfEvent } from "common/utils/mixpanel/submit-dtf-events";
import canvaStore from "./canvaStore";
import CanvaModal from "./CanvaModal.vue";
import CanvaPortal from "./CanvaPortal.vue";
import CanvaTrigger from "./CanvaTrigger.vue";

export default function CanvaModule({
  fileLanding,
  namespace,
  replica = false,
  settings = {},
  skipSettingsLoading = false,
  skipInitialModalShow = false,
  onClick,
  ...restProps
}: any) {
  const AUTO_START_QUERY_PARAM = "open_canva_modal_on_start";
  const store = canvaStore.useStore();
  const [modalRender, setModalRender] = useState(false);
  const triggerId = `canva-button-${namespace}`;

  function handleCanva(skipCanvaModal = false) {
    if (onClick) onClick();
    const args = getQueryParams();
    // @ts-expect-error TS migration
    if (!args[AUTO_START_QUERY_PARAM]) {
      submitDtfEvent("canva_button_click", { namespace });
    }
    const storeSettings = store.getters["canva/settings"];
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    if (!storeSettings.authorized) {
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      window.location.href = storeSettings.url;
      return;
    }
    setModalRender(true);
    queueMicrotask(() => {
      if (!skipCanvaModal) {
        // @ts-expect-error TS(2304): Cannot find name 'jQuery'.
        jQuery(store.getters["canva/$modal"]).modal("show");
      }
      store.dispatch("canva/resetModalState");
    });
  }

  function handleProxy() {
    document.getElementById(triggerId)?.click();
  }

  const settingsKey = JSON.stringify(settings);
  useEffect(() => {
    store.commit("canva/setSettings", settings);
  }, [settingsKey]);

  useEffect(() => {
    async function mount() {
      if (settings) {
        store.commit("canva/setSettings", settings);
      }
      if (replica) return;
      store.commit("canva/$setFileInput", document.querySelector(fileLanding));
      if (!skipSettingsLoading) {
        await store.dispatch("canva/fetchSettings", namespace);
      }
      // TODO(vue-migration): async callbacks read store getters after await — possible stale closure
      const args = getQueryParams();
      const storeSettings = store.getters["canva/settings"];
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      if (args[AUTO_START_QUERY_PARAM] && storeSettings.authorized) {
        handleCanva(skipInitialModalShow);
        removeQueryParam(AUTO_START_QUERY_PARAM);
        submitDtfEvent("canva_account_linked", { namespace });
      }
    }
    mount();
  }, []);

  return (
    <>
      {replica ? (
        <CanvaTrigger
          {...restProps}
          className={cn(`canva-trigger--${namespace}`, restProps.className)}
          onClick={handleProxy}
          data-testid="canva-trigger"
        />
      ) : (
        <>
          <CanvaTrigger
            className={cn(`canva-trigger--${namespace}`)}
            id={triggerId}
            onClick={handleCanva}
            data-testid="canva-trigger-1"
          />

          {modalRender ? (
            <CanvaPortal
              component={CanvaModal}
              props={{
                className: cn(`canva-modal--${namespace}`),
                store
              }}
              data-testid="canva-portal"
            />
          ) : null}
        </>
      )}
    </>
  );
}
